// extracted by mini-css-extract-plugin
export default {"comment":"ReviewComment_comment__TVLzC"};